<template>
  <div class="info-box">
    <div
      class="flex-1 grid gap-x-3 overflow-hidden"
      style="grid-template-columns: 20% 1fr"
    >
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="overflow-y-auto pr-3"
      >
        <strong>基本信息</strong>
        <el-form-item
          label="成本类型"
          prop="d_cost_type_pid"
          :rules="[
            { required: true, message: '请选择成本类型', trigger: 'blur' },
          ]"
        >
          <template #label>
            <div class="float-right flex items-baseline">
              <text class="whitespace-nowrap">公司地址</text>
              <text class="ml-3 text-orange-500 text-xs">
                物料包括：会议网站、设备租赁、会议物料；其它均为费用大类，请注意选择！
              </text>
            </div>
          </template>

          <!-- <template #label>
            <div class="float-right">
              <text>成本类型</text>
              <text class="text-xs text-gray-400"
                >物料包括：会议网站、设备租赁、会议物料；其它均为费用大类，请注意选择！</text
              >
            </div>
          </template> -->
          <el-select v-model="state.model.d_cost_type_pid" class="!w-96">
            <template #label="{ label, value }">
              <div class="flex gap-x-5 !w-full">
                <text>{{ label.name }}</text>
                <div
                  class="flex flex-col items-end flex-1 text-gray-400"
                  style="font-size: 12px"
                >
                  {{ label.description }}
                </div>
              </div>
            </template>
            <el-option
              v-for="item in state.cblx_data"
              :key="item"
              :label="item"
              :value="item.id"
            >
              <div class="flex gap-x-5 !w-full">
                <text>{{ item.name }}</text>
                <div
                  class="flex flex-col items-end flex-1 text-gray-400"
                  style="font-size: 12px"
                >
                  {{ item.description }}
                </div>
              </div>
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadCblx()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          label="采购名称"
          prop="name"
          :rules="[
            { required: true, message: '请输入采购名称', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item label="供应商采购">
          <el-switch
            v-model="state.model.is_supplier_purchase"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item
          label="供应商"
          prop="name"
          :rules="[
            { required: true, message: '请选择供应商', trigger: 'blur' },
          ]"
          v-if="state.model.is_supplier_purchase"
        >
          <el-select
            v-model="state.model.supplier_id"
            :disabled="state.supplier_id_disabled"
          >
            <template #label="{ label, value }">
              <div class="flex gap-x-5 !w-full">
                <text>{{ label.name }}</text>
                <div
                  class="flex flex-col items-end flex-1 text-gray-400"
                  style="font-size: 12px"
                >
                  {{ label.number }}
                </div>
              </div>
            </template>
            <el-option
              v-for="item in state.gys_data"
              :key="item"
              :label="item"
              :value="item.id"
            >
              <div class="flex gap-x-5 !w-full">
                <text>{{ item.name }}</text>
                <div
                  class="flex flex-col items-end flex-1 text-gray-400"
                  style="font-size: 12px"
                >
                  <text>{{ item.number }}</text>
                </div>
              </div>
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadGys()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="附件">
          <c_UploadFile
            :key="state.model.id"
            :value="state.model.files"
            @change="
              (data) => {
                state.model.files = data;
              }
            "
          />
        </el-form-item>
        <!-- <el-form-item label="附件">
          <template #label>
            <div class="flex items-center">
              <text>附件</text>
              <el-upload
                :show-file-list="false"
                :auto-upload="false"
                multiple
                :on-change="onFileChange"
              >
                <el-button type="primary" size="small" link icon="plus">
                  上传
                </el-button>
              </el-upload>
            </div>
          </template>
          <div class="w-full">
            <ul
              v-for="(file, index) in state.model.files"
              class="grid items-center"
              style="grid-template-columns: 1fr auto"
            >
              <text>{{ file.origin_filename }}</text>
              <el-icon
                color="#f00"
                @click.stop="state.model.files?.splice(index, 1)"
                class="hover:scale-110 text-red-400 cursor-pointer"
              >
                <Close />
              </el-icon>
            </ul>
          </div>
        </el-form-item> -->
      </el-form>
      <div class="flex flex-col overflow-hidden">
        <ul class="flex items-center">
          <strong class="flex-1">采购明细</strong>
          <li class="text-xs text-gray-400 flex items-center">
            共
            <strong class="text-blue-500">{{ state.list_data?.length }}</strong>
            条采购明细，合计
            <c_money :key="state.total" :value="state.total" class="mr-10" />
          </li>
          <el-button
            type="danger"
            icon="delete"
            link
            :disabled="!state.list_data || state.list_data?.length <= 0"
            @click="onClear()"
          >
            清空采购明细
          </el-button>
          <el-button
            :type="state.model.d_cost_type_pid ? 'primary' : ''"
            icon="edit"
            link
            @click="state.showEdit = true"
            :disabled="!state.model.d_cost_type_pid"
          >
            调整明细项
          </el-button>
          <el-tooltip
            v-if="!state.model.d_cost_type_pid"
            effect="dark"
            content="请先选择成本类型"
          >
            <el-icon class="cursor-pointer">
              <QuestionFilled />
            </el-icon>
          </el-tooltip>
        </ul>
        <el-table
          :data="state.list_data"
          v-loading="!Array.isArray(state.list_data)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          class="flex-1 mt-1"
        >
          <el-table-column
            label="类型"
            prop="d_cost_type_name"
            :formatter="$tab_TextFormat"
            :width="100"
          />
          <el-table-column
            label="所属分会"
            prop="meeting_place_name"
            :formatter="$tab_TextFormat"
            :width="240"
          />
          <el-table-column :min-width="140">
            <template #header>
              <div class="c-table-col-header" label1="名称" label2="规格" />
            </template>
            <template #default="{ row }">
              <text>{{ row.name }}</text>
              <text class="text-gray-400 text-xs">{{ row.specification }}</text>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <div class="c-table-col-header" label1="采购单价" label2="单位" />
            </template>
            <template #default="{ row }">
              <text>{{ $priceFormat(row.price) }}</text>
              <text class="text-gray-400 text-xs">{{
                "/" + row.d_measure_unit_name
              }}</text>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <div class="c-table-col-header" label1="采购数量" label2="天数" />
            </template>
            <template #default="{ row }">
              <text>{{ row.count }}</text>
              <text class="text-gray-400 text-xs">{{
                "/" + (row.day_count || "-")
              }}</text>
            </template>
          </el-table-column>
          <el-table-column
            label="备注"
            prop="remark"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="采购金额"
            prop="total"
            :formatter="$tab_PriceFormat"
          />
        </el-table>
      </div>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
  <el-dialog
    v-model="state.showEdit"
    title="调整明细项"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showEdit = false;
      }
    "
    width="95%"
    style="height: 95%; max-height: 95%"
    :modal="true"
  >
    <c_record
      :list_data="state.list_data || []"
      :meeting_id="props.meeting_id"
      :data="state.list_data"
      :total="state.total"
      :d_cost_type_pid="state.model?.d_cost_type_pid"
      :supplier_id="state.model?.supplier_id"
      @close="
        state.showEdit = false;
        onLoad();
      "
      @confirm="onEditConfirm"
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_purchase_detail,
  meeting_purchase_add,
  meeting_purchase_edit,
} from "@/http/meeting";
import { dic_getCostType, data_getSupplier } from "@/http/data";
import { attachment_upload } from "@/http/attachment";
import { toDecimal, post_response } from "@/utils/funcs";
import { ElMessage } from "element-plus";

import c_record from "./Record.vue";

export default {
  components: { c_record },
  props: {
    meeting_id: Number,
    id: Number,
  },
  setup(props, { emit }) {
    let del_item_id = []; //删除的明细项id集合，主要用于编辑提交时
    const formDom = ref(null);
    const state = reactive({
      model: {
        meeting_id: props.meeting_id,
        files: [],
        is_supplier_purchase: 0,
      },
      list_data: [],
    });
    onMounted(() => {
      onLoadCblx();
      onLoadGys();
      if (props.id) {
        meeting_purchase_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.total = data.amount;
            state.model.files = data.attachment || [];

            state.list_data = data.meetingPurchaseItemData?.list?.map((m) => {
              return {
                id: m.id,
                handle: "edit", //handle: "add"表示新增，"edit"表示编辑
                type: m.type, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
                meeting_place: { id: m.meeting_place_id },
                meeting_place_id: m.meeting_place_id,
                meeting_place_name: m.meetingPlace?.name,
                supplier_cost_item_id: m.supplier_cost_item_id,
                cost_item_id: m.cost_item_id,
                d_cost_type_pid: m.d_cost_type_pid,
                d_cost_type: { id: m.d_cost_type_id },
                d_cost_type_id: m.d_cost_type_id,
                d_cost_type_name: m.d_cost_type_name,
                name: m.name,
                d_measure_unit: { id: m.d_measure_unit_id },
                d_measure_unit_id: m.d_measure_unit_id,
                d_measure_unit_name: m.d_measure_unit_name,
                specification: m.specification,
                price: m.price,
                count: m.count,
                day_count: m.day_count,
                remark: m.remark,
                total: toDecimal(m.amount?.toString() || "0"),
              };
            });
            state.supplier_id_disabled = state.list_data.some(
              (w) => w.type == 2,
            );
          }
        });
      }
    });

    //获取成本类型
    const onLoadCblx = () => {
      dic_getCostType({ pid: 0 }).then((res) => {
        if (res.status == 200) state.cblx_data = res.data?.data || [];
      });
    };

    //获取供应商
    const onLoadGys = () => {
      data_getSupplier().then((res) => {
        if (res.status == 200) state.gys_data = res.data?.data?.list || [];
      });
    };

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.model.files = [...state.model.files, ...res.data.data];
        }
      });
    };

    //明细项调整提交事件，data-采购明细必须有值才可以提交
    const onEditConfirm = ({ rows, total, del_ids }) => {
      state.list_data = rows;
      state.d_cost_type_pid_disabled = true; //此处禁用表单的成本类型选择，防止用户修改类型导致采购明细中的物料无当前类型不匹配
      state.supplier_id_disabled = rows.some((w) => w.type == 2); //校验采购明细中是否有从供应商常用项中选择的明细，如果有则禁用供应商选择，防止切换供应商导致采购明细不匹配
      state.total = total;
      del_item_id = [...new Set([...del_item_id, ...del_ids])]; //赋值删除的明细项id集合
      state.showEdit = false;
    };

    //清空采购明细
    const onClear = () => {
      del_item_id = [
        ...del_item_id,
        ...state.list_data.filter((m) => m.handle == "edit").map((m) => m.id),
      ];
      state.list_data = [];
      state.total = 0;
      state.d_cost_type_pid_disabled = false;
      state.supplier_id_disabled = false;
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (!state.list_data || state.list_data?.length <= 0) {
            ElMessage.error("请添加采购明细");
            return false;
          }
          state.model.attachment = JSON.stringify(
            state.model.files?.map((m) => m.id),
          );

          if (props.id) {
            state.model.add_item_data = state.list_data.filter(
              (m) => m.handle == "add",
            );
            state.model.edit_item_data = state.list_data.filter(
              (m) => m.handle == "edit",
            );
            state.model.del_item_id = del_item_id;
            meeting_purchase_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            state.model.add_item_data = state.list_data;
            meeting_purchase_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadCblx,
      onLoadGys,
      onFileChange,
      onEditConfirm,
      onClear,
    };
  },
};
</script>
<style scoped></style>
